(function () {
  window.tsAjaxAccessoryCartLoaded = true;

  function refreshAndOpenCartDrawer() {
    return fetch('/cart?section_id=cart-drawer')
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newCartItems = doc.querySelector('cart-items-component');
        var currentCartItems = document.querySelector('cart-items-component');

        if (newCartItems && currentCartItems) {
        var currentSectionId = currentCartItems.dataset.sectionId;
        var sectionWrapper = currentCartItems.closest('[id^="shopify-section-"]');

        if (!currentSectionId && sectionWrapper) {
          currentSectionId = sectionWrapper.id.replace('shopify-section-', '');
        }

        if (currentSectionId) {
          newCartItems.dataset.sectionId = currentSectionId;
        }

        currentCartItems.replaceWith(newCartItems);
      }

        var newTrigger = doc.querySelector('[data-testid="cart-drawer-trigger"]');
        var currentTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');

        if (newTrigger && currentTrigger) {
          currentTrigger.innerHTML = newTrigger.innerHTML;
        }

        var cartDrawer = document.querySelector('cart-drawer-component');

        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      });
  }

  function setLoading(control, isLoading) {
    if (!control) return;

    if (isLoading) {
      control.dataset.originalHtml = control.innerHTML;
      control.disabled = true;
      control.style.opacity = '0.7';
      control.style.pointerEvents = 'none';
      control.innerHTML = 'Adding...';
    } else {
      control.disabled = false;
      control.style.opacity = '';
      control.style.pointerEvents = '';

      if (control.dataset.originalHtml) {
        control.innerHTML = control.dataset.originalHtml;
      }
    }
  }

  function isCartAddForm(form) {
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  function isAccessoryCartForm(form) {
    return (
      form.classList.contains('ts-accessory-product-form') ||
      Boolean(form.closest('.ts-accessory-cart-form'))
    );
  }

  function addFormToCart(form) {
    var button = form.querySelector('button[type="submit"], button:not([type])');
    var formData = new FormData(form);

    setLoading(button, true);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            throw errorData;
          });
        }

        return response.json();
      })
      .then(function (response) {
        return refreshAndOpenCartDrawer().then(function () {
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: response }));
        });
      })
      .catch(function (error) {
        console.error('Accessory form add to cart failed:', error);
        alert('Could not add this item to the cart. Please try again.');
      })
      .finally(function () {
        setLoading(button, false);
      });
  }

  function addButtonVariantToCart(button) {
    var variantId = button.dataset.variantId;

    if (!variantId) return;

    setLoading(button, true);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            throw errorData;
          });
        }

        return response.json();
      })
      .then(function (response) {
        return refreshAndOpenCartDrawer().then(function () {
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: response }));
        });
      })
      .catch(function (error) {
        console.error('Accessory button add to cart failed:', error);
        alert('Could not add this item to the cart. Please try again.');
      })
      .finally(function () {
        setLoading(button, false);
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (!isCartAddForm(form)) return;
      if (!isAccessoryCartForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addFormToCart(form);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.ts-add-to-cart-btn');

      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addButtonVariantToCart(button);
    },
    true
  );
})();